export default "__VITE_PUBLIC_ASSET__898c0e4a__"